import React from 'react';
import Text from './text';

const ViewTitle = props => <Text fontWeight="semibold" fontSize={6} {...props} />;

export default ViewTitle;
